import { render, staticRenderFns } from "./DeepDive.vue?vue&type=template&id=dceb3990&scoped=true&"
import script from "./DeepDive.vue?vue&type=script&lang=js&"
export * from "./DeepDive.vue?vue&type=script&lang=js&"
import style0 from "./DeepDive.vue?vue&type=style&index=0&id=dceb3990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceb3990",
  null
  
)

export default component.exports